import type { ExtractPropTypes, UnwrapNestedRefs } from "vue";
import { reactive } from "vue";
import { props } from "quick-vue-components/index";
import { getNoticesListV2 } from "@user-center/api/mall";
import { getCurrentLocale } from "@user-center/utils/i18n";
import {
  filterActiveNotices,
  isNoticeHiddenByScope,
  localizeNotices,
} from "./noticeUtils";
import { useMainStore } from "~/composables/store";

export interface NoticeBarType {
  noticeBarState: UnwrapNestedRefs<NoticeBarStateType>;
  getListAction():void
}
export type NoticeBarStateType = {
  noticeDataVisible: boolean;

  viewNoticeIdx: number;
  findNoticeDatas: any[];
};
export const NoticeBarProps = props.buildProps({
  isShowBar: {
    type: Boolean,
    default: true,
  },
  autoPopup: {
    type: Boolean,
    default: true,
  },
  pageSize: {
    type: Number,
    default: 99,
  },
  storageScope: {
    type: String,
    default: "default",
  },
});
export type NoticeBarPropsType = ExtractPropTypes<typeof NoticeBarProps>;

export function useGetNoticesList(props?:NoticeBarPropsType): NoticeBarType {
  const store = useMainStore();
  const noticeBarState: UnwrapNestedRefs<NoticeBarStateType> = reactive({
    noticeDataVisible: false,
    viewNoticeIdx: 0,
    findNoticeDatas: [],
  });
  function getListAction() {
    getNoticesListV2({ pageNum: 1, pageSize: props?.pageSize || 99 }).then((res: any): void => {
      if (res.success && res.data && res.data.dataList) {
        const findItems: any[] = localizeNotices(
          filterActiveNotices(res.data.dataList || [])
        );
        store.setHasVisibleNotice(findItems.length > 0);
        if (findItems.length) {
          noticeBarState.findNoticeDatas = findItems;
          noticeBarState.viewNoticeIdx = 0;
          if (
            props?.autoPopup !== false &&
            !window.sessionStorage.getItem("isNoticeBarOpen") &&
            !isNoticeHiddenByScope(props?.storageScope || "default")
          ) {
            window.sessionStorage.setItem("isNoticeBarOpen", "1");
            noticeBarState.noticeDataVisible = true;
          }
        }
      } else {
        store.setHasVisibleNotice(false);
      }
    }).catch(() => {
      store.setHasVisibleNotice(false);
    });
  }

  return {
    getListAction,
    noticeBarState,
  };
}
